import React, { useState } from 'react'
import { useSelector } from 'react-redux'

import Sites from './Sites'
import Imports from '../../Realtime/Imports'
import Tabs from '../../utils/Tabs'

const tabOptions = [
  {
    name: 'Sites',
    value: 'sites'
  },
  {
    name: 'Import History',
    value: 'imports'
  }
]

const Content = () => {
  const facility = useSelector(store => store.facilities.facility)
  const [contentActive, setContentActive] = useState('sites')

  return (
    <div className="mt-4">
      <Tabs large options={tabOptions} onChange={setContentActive} />
      {contentActive === 'sites' && <Sites />}
      {contentActive === 'imports' && <Imports short facilityId={facility.id} />}
    </div>
  )
}

export default Content
